"use strict";

exports.__esModule = true;
exports.default = where;
var _filter = _interopRequireDefault(require("./filter.js"));
var _matcher = _interopRequireDefault(require("./matcher.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return (0, _filter.default)(obj, (0, _matcher.default)(attrs));
}